import React from 'react'
import { TickCircle } from 'iconsax-react'

import useStyles from './styles'

const Environment = ({ name, active, onClick }) => {
  const classes = useStyles()

  return (
    <div onClick={onClick} className={active ? classes.active : classes.env}>
      <div className={classes.name}>{name}</div>
      {active ? (
        <TickCircle />
      ) : (
        <TickCircle style={{ visibility: 'hidden' }} />
      )}
    </div>
  )
}

export default Environment
